import {alertError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {Store} from 'redux'
import {selSharedAppState} from 'module/SharedAppState/selector/SharedAppStateSelector'
import {appInitialized} from 'common/init'
import {filter, map, mergeMap} from 'rxjs/operators'
import {Epic} from 'redux-observable'
import {distinctUntilChangedWithKeys} from 'util/rxjsOperators/distinctUntilChangedWithKeys'
import {sharedAppStateSetAction} from 'module/SharedAppState/action/SharedAppStateAction'
import {SharedAppState} from 'module/SharedAppState/type/SharedAppState'

let _store: Store | null = null

export let changeCallbacks: { id: number, fn: Function, filterAttrs?: string[] }[] = []
let cbID: number = 0;
export function addSharedAppStateChangeCallback(fn: Function, filterAttrs?: string[]) {
	const id = cbID++
	changeCallbacks.push({id, fn, filterAttrs}) // returns added index
	return id;
}
export function removeSharedAppStateChangeCallback(id: number) {
	changeCallbacks = changeCallbacks.filter(x => x.id !== id)
}

export const SharedAppStateChangedEpic: Epic = (action$, state$) => action$.pipe(
	filter(sharedAppStateSetAction.match),
	map(() => selSharedAppState(state$.value)),
	distinctUntilChangedWithKeys(selSharedAppState(state$.value)),
	mergeMap(({changedKeys, value: sharedAppState}) => {
		changeCallbacks.forEach(x => {
			if (!x.filterAttrs || x.filterAttrs.some(a => changedKeys.includes(a))) {
				x.fn(sharedAppState)
			}
		})
		return []
	}),
)
appInitialized.then(({store, epicMiddleware}) => {
	_store = store
	epicMiddleware.run(SharedAppStateChangedEpic)
})

//@deprecated
export function compat_getSharedAppState() {
	if (!_store) {
		void alertError("invalid call to compat_getSharedAppState")
		return;
	}
	const sharedAppState = selSharedAppState(_store.getState())
	return {...sharedAppState}
}


//@deprecated
export function compat_setSharedAppState(stateChange: SharedAppState) {
	if (!_store) {
		void alertError("invalid call to compat_getSharedAppState")
		return;
	}
	_store.dispatch(sharedAppStateSetAction(stateChange))
}